export default __webpack_public_path__ + "noMustVisitUniversities.svg";